'use client'

import dynamic from 'next/dynamic'

import { useZoom } from './contexts/useZoom'

const ZoomBody = dynamic(() =>
	import('pdp/src/components/Gallery/Zoom/ZoomBody').then((mod) => mod.ZoomBody)
)

export function Zoom(): React.ReactNode {
	const { image } = useZoom()

	return image ? <ZoomBody /> : null
}
